export const SPECIAL_CASES_ENDPOINT = '/import-config/special-cases';

export const sourceColumns = [
  ['department_name', 'tools.import_validator.department'],
  ['season_name', 'tools.import_validator.season'],
  ['work_process', 'tools.import_validator.work_process'],
  ['person', 'tools.import_validator.person'],
  ['registration_number', 'tools.import_validator.registration_number'],
  ['work_machine_name', 'tools.import_validator.work_machine_name'],
  ['parcel_name', 'common.parcel'],
  ['culture', 'common.culture'],
  ['start_date', 'tools.import_validator.start_date', 'datetime', 'yyyy-MM-dd HH:mm'],
  ['end_date', 'tools.import_validator.end_date', 'datetime', 'yyyy-MM-dd HH:mm'],
  ['surface', 'common.surface_ha', 'number'],
  ['net_surface_worked', 'tools.import_validator.net_surface_worked', 'number'],
  ['surface_worked_with_overlaps', 'tools.import_validator.surface_worked_with_overlaps', 'number'],
  ['working_time', 'tools.import_validator.working_time'],
  ['ignition_time', 'tools.import_validator.ignition_time'],
  ['inactive_time', 'tools.import_validator.inactive_time'],
  ['time_spent_on_parcel', 'tools.import_validator.time_spent_on_parcel'],
  ['fuel_consumption', 'tools.import_validator.fuel_consumption', 'number'],
  ['consumption_per_hour', 'tools.import_validator.consumption_per_hour', 'number'],
  ['consumption_per_ha', 'tools.import_validator.consumption_per_ha', 'number'],
  ['notes', 'common.notes'],
];

export const numericFields = [
  ['net_surface_worked', 'tools.import_validator.net_surface_worked'],
  ['surface_worked_with_overlaps', 'tools.import_validator.surface_worked_with_overlaps'],
  ['fuel_consumption', 'tools.import_validator.fuel_consumption'],
  ['consumption_per_hour', 'tools.import_validator.consumption_per_hour'],
  ['consumption_per_ha', 'tools.import_validator.consumption_per_ha'],
];

export const durationFields = [
  ['working_time', 'tools.import_validator.working_time'],
  ['ignition_time', 'tools.import_validator.ignition_time'],
  ['inactive_time', 'tools.import_validator.inactive_time'],
  ['time_spent_on_parcel', 'tools.import_validator.time_spent_on_parcel'],
];